module.exports = __webpack_public_path__ + "static/media/diagonal.ca423a5e.png";